/** Non-empty sentinel so Nike DropDown floating labels stay active (empty string overlaps). */
export const PG_FILTER_ALL = "__all__";

export function isFilterAll(value) {
  return value === PG_FILTER_ALL || value === "" || value == null;
}
